var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.86 31.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0a0a",
    d: "M15.93,0A15.86,15.86,0,1,0,31.86,15.86,15.89,15.89,0,0,0,15.93,0m0,30.12A14.27,14.27,0,1,1,30.27,15.86,14.3,14.3,0,0,1,15.93,30.12M21.71,11a.57.57,0,0,0-.8,0l-7.17,7.15-3.43-3.41a.55.55,0,0,0-.8,0l-1.2,1.19a.57.57,0,0,0,0,.8l3.81,3.81.83.82.19.2.18.17a.54.54,0,0,0,.79,0L22.9,13a.55.55,0,0,0,0-.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickInCircle);
export default __webpack_public_path__ + "static/media/tick-in-circle.9edca4bf8ac0cc58ccb05a9f762be3f5.svg";
export { ForwardRef as ReactComponent };